module.exports = __webpack_public_path__ + "img/icon-white-17.f83debdc.svg";